import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { createDataTourStep } from '../../utils/shared/demoModeUtils';

const LinkWrapper = ({ configName, path, className, content }) => {
    return (
        <Link
            data-tour-step={createDataTourStep(configName)}
            data-tour-allow-interaction
            to={path}
            className={className}
        >
            {content}
        </Link>
    );
};

LinkWrapper.defaultProps = {
    configName: '',
    path: {},
    className: '',
    content: null,
};

LinkWrapper.propTypes = {
    configName: PropTypes.string,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    className: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default LinkWrapper;
